import { __decorate } from "tslib";
import { injectable } from 'tsyringe';
import { createElement } from '@gn-audio/core/common/templating';
import './basket-loader.plugin.scss';
import template from './basket-loader.plugin.html';
var BasketLoaderPlugin = /** @class */ (function () {
    function BasketLoaderPlugin() {
        var _this = this;
        this.showEvents = [
            "add-to-basket" /* BasketEvent.AddToBasket */,
            "remove-from-basket" /* BasketEvent.RemoveFromBasket */,
            "set-quantity" /* BasketEvent.SetQuantity */,
            "apply-coupon" /* BasketEvent.ApplyCoupon */,
            "remove-coupon" /* BasketEvent.RemoveCoupon */,
            "show-loader-ui" /* BasketEvent.ShowLoaderUI */,
            "set-service-value" /* BasketEvent.SetServiceValue */,
        ];
        this.hideEvents = [
            "hide-basket-ui" /* BasketEvent.HideBasketUI */,
            "basket-updated" /* BasketEvent.BasketUpdated */,
            "error-occurred" /* BasketEvent.ErrorOccurred */,
            "hide-loader-ui" /* BasketEvent.HideLoaderUI */,
        ];
        this.show = function () {
            _this.loaderElement.classList.add("visible" /* CssClass.Visible */);
        };
        this.hide = function () {
            _this.loaderElement.classList.remove("visible" /* CssClass.Visible */);
        };
    }
    BasketLoaderPlugin.prototype.register = function (_a) {
        var eventBus = _a.eventBus;
        this.loaderElement = document.body.appendChild(createElement(template, {}));
        this.eventBus = eventBus;
        this.eventBus.subscribe(this.showEvents, this.show);
        this.eventBus.subscribe(this.hideEvents, this.hide);
    };
    BasketLoaderPlugin.prototype.shouldRegister = function () {
        return true;
    };
    BasketLoaderPlugin.prototype.unregister = function () {
        this.loaderElement.remove();
        this.eventBus.unsubscribe(this.showEvents, this.show);
        this.eventBus.unsubscribe(this.hideEvents, this.hide);
    };
    BasketLoaderPlugin = __decorate([
        injectable()
    ], BasketLoaderPlugin);
    return BasketLoaderPlugin;
}());
export { BasketLoaderPlugin };
